import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/lib/i18n";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CaseWorkspace from "@/pages/CaseWorkspace";
import Pricing from "@/pages/Pricing";
import AuthCallback from "@/pages/AuthCallback";
import BillingReturn from "@/pages/BillingReturn";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen bg-[#0a0a0c]" />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Inner() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/billing/return" element={<BillingReturn />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/cases/:caseId" element={<Protected><CaseWorkspace /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <Inner />
            <Toaster position="top-right" theme="dark" />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
